module.exports = __webpack_public_path__ + "static/media/puzzle0102.4662213b.jpg";